<template>
    <div>
        <Steps />
        <!-- <StickyTopPolicyCard
            v-if="aplCatl===aplCatlCode.POLICY  && ($route.meta.code || $route.name===routeName.CONFIRM_DATA || $route.name === routeName.REFUND_PAYMENT)"
        /> -->
        <StickyTopPolicyCard v-if="aplCatl===aplCatlCode.POLICY && (showCardWhiteList || $route.meta.code)" />
        <router-view />
    </div>
</template>
<script>
import Steps from '@/components/layout/Steps.vue';
import StickyTopPolicyCard from '@/components/layout/StickyTopPolicyCard.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import routeName from '@/router/constant.js';
import aplCatlCode from '@/json/aplCatlCode';

export default {
    components: {
        Steps,
        StickyTopPolicyCard,
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const aplCatl = computed(() => store.state.services.aplCatl);

        const showCardWhiteList = computed(() => {
            const whiteList = [routeName.CONFIRM_DATA, routeName.REFUND_PAYMENT, routeName.RISK_NOTICE];
            const index = whiteList.findIndex(i => route.name === i);
            return index !== -1;
        });

        return {
            aplCatlCode,
            aplCatl,
            routeName,
            showCardWhiteList
        };
    }
};
</script>
